import { Controller, useFormContext } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const IdNumber = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={`subjectsInfo.${index1 as 0}.idsInfo.${index2 as 0}.idNumber`}
      control={control}
      render={({ field }) => (
        <FF2 field={field} label="Number" input={(props) => <TextInput {...props} disabled={isAllInfoUnavailable} />} />
      )}
    />
  )
}
